import styled from 'styled-components';

export default styled.div`
	.motif-accordion-title-content {
		flex: 1;
		min-width: 0;
	}
`;
